import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AssetDetailPage from './pages/AssetDetailPage';
import MapViewPage from './pages/MapViewPage';
import DigitalTwinPage from './pages/DigitalTwinPage';
import AlertsPage from './pages/AlertsPage';
import SCAlertsPage from './pages/SCAlertsPage';
import TasksPage from './pages/TasksPage';
import SOHReportPage from './pages/SOHReportPage';
import SOCReportPage from './pages/SOCReportPage';
import DegradationReportPage from './pages/DegradationReportPage';
import CyberPhysicalSecurityPage from './pages/CyberPhysicalSecurityPage';
import PhysicalSecurityPage from './pages/PhysicalSecurityPage';
import RecyclingPage from './pages/RecyclingPage';
import RecyclingDetailPage from './pages/RecyclingDetailPage';
import CertificationReportPage from './pages/CertificationReportPage';
import EolProjectsPage from './pages/EolProjectsPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/asset/:id" element={<AssetDetailPage />} />
          <Route path="/map" element={<MapViewPage />} />
          <Route path="/digital-twin/:id" element={<DigitalTwinPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/sca-alerts" element={<SCAlertsPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/reports/soh" element={<SOHReportPage />} />
          <Route path="/reports/soc" element={<SOCReportPage />} />
          <Route path="/reports/degradation" element={<DegradationReportPage />} />
          <Route path="/cyber-security" element={<CyberPhysicalSecurityPage />} />
          <Route path="/physical-security" element={<PhysicalSecurityPage />} />
          <Route path="/environmental" element={<PhysicalSecurityPage />} />
          <Route path="/recycling" element={<RecyclingPage />} />
          <Route path="/recycling/projects" element={<EolProjectsPage />} />
          <Route path="/recycling/certificates" element={<CertificationReportPage />} />
          <Route path="/recycling/:id" element={<RecyclingDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;